var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfiniteLineDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.454,
    height: 23.548,
    viewBox: "0 0 24.454 23.548",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5ff7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5ff7c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(-9.539 -9.185)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_75",
    "data-name": "Line 75",
    d: "M1.279,2.557-.707.645.7-.707,2.683,1.205Z",
    transform: "translate(28.502 12.597)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_77",
    "data-name": "Line 77",
    d: "M1.279,2.557-.707.645.7-.707,2.683,1.205Z",
    transform: "translate(10.246 30.176)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_76",
    "data-name": "Line 76",
    d: "M1.279,2.557-.707.645.7-.707,2.683,1.205Z",
    transform: "translate(31.31 9.893)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_78",
    "data-name": "Line 78",
    d: "M1.279,2.557-.707.645.7-.707,2.683,1.205Z",
    transform: "translate(13.055 27.471)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_79",
    "data-name": "Line 79",
    d: "M1.279,12.023-.707,10.111,10.527-.707l1.986,1.912Z",
    transform: "translate(15.863 15.301)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfiniteLineDark);
export default __webpack_public_path__ + "static/media/infinite-line-dark.be7a85a362a4d696f55ab3bb737a57a7.svg";
export { ForwardRef as ReactComponent };